import React from 'react';
import PropTypes from 'prop-types';

function addChildProps(child, props) {
  if (!child) {
    return null;
  }
  if (_.isString(child.type)) {
    // this is DOM element
    return child;
  }
  return React.cloneElement(child, props);
}


export default class DataComponent extends React.Component {

  static propTypes = {
    children: PropTypes.any,
  };

  get childProps() {
    return null;
  }

  render() {
    const childProps = this.childProps;
    const { children } = this.props;

    if (!childProps || !children) {
      return null;
    }

    const props = _.omit(this.props, ['isFetching', 'children']);

    const combinedProps = { ...props, ...childProps };

    if (!_.isArray(children)) {
      return addChildProps(children, combinedProps);
    }

    return (
      <section>
        {React.Children.map(children, child => addChildProps(child, combinedProps))}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/data-components/_data-component.js